import { 
	GET_PROJECT_DRAWING_OFFICE_IFAS, 
	GET_PROJECT_DRAWING_OFFICE_IFA,
	CREATE_PROJECT_DRAWING_OFFICE_IFA,
	UPDATE_PROJECT_DRAWING_OFFICE_IFA,
	DESTROY_PROJECT_DRAWING_OFFICE_IFA,
} from "./actions"

export function ProjectDrawingOfficeIfasReducer(state = {}, action) {
	switch (action.type) {
		case `${GET_PROJECT_DRAWING_OFFICE_IFAS}_FULFILLED`:{
			return _.mapKeys(action.payload.data, "id");
		}
		case `${GET_PROJECT_DRAWING_OFFICE_IFA}_FULFILLED`:
		case `${CREATE_PROJECT_DRAWING_OFFICE_IFA}_FULFILLED`:
		case `${UPDATE_PROJECT_DRAWING_OFFICE_IFA}_FULFILLED`:{
			let newState = _.clone(state);
			const newItem = action.payload.data;
			const id = _.get(newItem,"id")
			newState[id] = newItem
			return newState;
		}		
		case `${DESTROY_PROJECT_DRAWING_OFFICE_IFA}_FULFILLED`:{
			let newState = _.clone(state);
			const deletedItem = action.payload.data;
			const id = _.get(deletedItem,"id")
			newState = _.filter(newState,i => i.id != id)
			return newState;
		}
		default:
			return state;
	}
}

